class CountdownTimer extends HTMLElement {
  connectedCallback() {
    const raw = this.dataset.end;
    const endDate = raw ? new Date(raw.replace(' ', 'T')) : null;

    if (!endDate || Number.isNaN(endDate.getTime())) {
      this.hidden = true;
      return;
    }

    this.unitsEl = this.querySelector('[data-countdown-units]');
    this.expiredEl = this.querySelector('[data-countdown-expired]');
    this.dayEl = this.querySelector('[data-unit="days"]');
    this.hourEl = this.querySelector('[data-unit="hours"]');
    this.minuteEl = this.querySelector('[data-unit="minutes"]');
    this.secondEl = this.querySelector('[data-unit="seconds"]');
    this.hideOnExpiry = this.dataset.hideOnExpiry === 'true';
    this.endTime = endDate.getTime();

    this.tick();
    this.timer = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
  }

  tick() {
    const diff = this.endTime - Date.now();

    if (diff <= 0) {
      window.clearInterval(this.timer);
      if (this.hideOnExpiry) {
        this.hidden = true;
        return;
      }
      if (this.unitsEl) this.unitsEl.hidden = true;
      if (this.expiredEl) this.expiredEl.hidden = false;
      return;
    }

    const pad = (value) => String(value).padStart(2, '0');
    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (this.dayEl) this.dayEl.textContent = pad(days);
    if (this.hourEl) this.hourEl.textContent = pad(hours);
    if (this.minuteEl) this.minuteEl.textContent = pad(minutes);
    if (this.secondEl) this.secondEl.textContent = pad(seconds);
  }
}

customElements.define('countdown-timer', CountdownTimer);
